export default __webpack_public_path__ + "img/a92ba690048296e33f64a34b72f05f19.svg";